export default __webpack_public_path__ + "static/media/5.7250a02e.jpeg";